import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';

const LocationServices = ( { row } ) => {
	const mapServices = useCallback( () => row.services
		.filter( ( { name } ) => name !== 'Indiana Counties' )
		.reduce( ( acc, category ) => {
			const services = category.items.map( service => ( // labels on backend
				<Label
					key={ service.id }
					size="mini"
					style={ { marginBottom: '0.23333334em' } }
				>
					{ service.name }
				</Label>
			) );

			return [ ...acc, ...services ];
		}, [] ), [ row.services ] );

	return (
		<span>
			{ mapServices() }
		</span>
	);
};

LocationServices.propTypes = { row: PropTypes.object.isRequired };

export default memo( LocationServices );
